export default __webpack_public_path__ + "static/media/green.18c52455.png";